import styled from "styled-components";
import { colors, breakpoints } from "definitions";

// Azul del paginador alineado al del header del site (navigation.darkBlue = #08255A).
const ACCENT = colors.navigation.darkBlue;
const ACCENT_HOVER = colors.hover.darkBlue;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.8rem;
	padding: 1.2rem 1rem;
	border-top: 1px solid ${colors.background.veryLightGray};
	background-color: ${colors.background.white};
	width: 100%;

	${breakpoints.tablet} {
		gap: 0.6rem;
		padding: 1rem 0.6rem;
	}
`;

export const Controls = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	justify-content: center;
	gap: 0.4rem;
`;

const baseChip = `
	min-width: 3.6rem;
	height: 3.6rem;
	padding: 0 1rem;
	border-radius: 4px;
	border: 1px solid ${colors.background.veryLightGray};
	background-color: ${colors.background.white};
	color: ${colors.fonts.darkGray};
	font-size: 1.4rem;
	font-family: inherit;
	cursor: pointer;
	transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;

	&:hover:not(:disabled) {
		background-color: ${ACCENT_HOVER};
		border-color: ${ACCENT_HOVER};
		color: ${colors.fonts.white};
	}

	&:disabled {
		opacity: 0.45;
		cursor: not-allowed;
	}
`;

export const PageButton = styled.button`
	${baseChip}
	font-weight: 500;
`;

export const PageNumber = styled.button`
	${baseChip}
	font-weight: ${({ active }) => (active ? 700 : 500)};
	background-color: ${({ active }) => (active ? ACCENT : colors.background.white)};
	color: ${({ active }) => (active ? colors.fonts.white : colors.fonts.darkGray)};
	border-color: ${({ active }) => (active ? ACCENT : colors.background.veryLightGray)};

	&:hover:not(:disabled) {
		background-color: ${({ active }) => (active ? ACCENT : ACCENT_HOVER)};
		color: ${colors.fonts.white};
		border-color: ${({ active }) => (active ? ACCENT : ACCENT_HOVER)};
	}
`;

export const Ellipsis = styled.span`
	min-width: 2.4rem;
	text-align: center;
	color: ${colors.fonts.darkGray};
	font-size: 1.4rem;
	user-select: none;
`;

export const RangeText = styled.span`
	font-size: 1.2rem;
	color: ${colors.fonts.darkGray};
	opacity: 0.7;
`;
